import { render, staticRenderFns } from "./PersonalityUserCard.vue?vue&type=template&id=cf1e2ba8&"
import script from "./PersonalityUserCard.vue?vue&type=script&lang=js&"
export * from "./PersonalityUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports